module.exports = __webpack_public_path__ + "img/illustration-project-empty-state.2f50a55c.png";